export const inventoryTypes = {
  bundle: 'bundle',
  product: 'product',
  notInventoryType: 'notInventoryType',
};

export const typeNames = {
  bundle: 'ContentfulProductBundle',
  product: 'ContentfulProduct',
};

/**
 * Determine if an item is a bundle or product
 * @param {object} item Product/bundle item
 */
export function identifyInventoryType(item) {
  const { __typename: typename } = item;
  switch (typename) {
    case typeNames.bundle:
      return inventoryTypes.bundle;
    case typeNames.product:
      return inventoryTypes.product;
    case Array.isArray(item):
      throw new Error(`Array of products isn't supported`);
    default:
      if (process.env.NODE_ENV === 'development') {
        console.warn('Unknown inventory type');
      }
      return inventoryTypes.notInventoryType;
  }
}
